<template>
  <div>
	  <section class="sp-logo sp1">
			<img src="@/assets/images/sp-logo.svg">
    </section>
    <header id="header">
			<div class="mask"></div>
			<div class="container1">
				<h1 class="pc1"><img src="@/assets/images/logo.svg"></h1>
				<h1 class="sp1"><img src="@/assets/images/free.svg"></h1>
				<div class="header-cont">
					<div class="left">
						<p>空き時間でおこずかい稼ぎ！<br>
						ベビーシッターに登録しませんか？</p>
						<a class="register pc1" href="#">登録面談会はこちら</a>
						<a class="appstore pc1" href="https://apps.apple.com/jp/app/comori/id1454794756?ls=1">
							<img src="@/assets/images/appstore.svg">
						</a>
						<div class="photos">
							<p>
								<img src="@/assets/images/img01.png">
							</p>
							<p>
								<img src="@/assets/images/img02.png">
							</p>
							<p>
								<img src="@/assets/images/img03.png">
							</p>
						</div>
					</div>
					<div class="right pc1">
						<p>
							<img src="@/assets/images/img04.png">
						</p>
					</div>
				</div>
			</div>
    </header>
    <section id="sec01" class="pc1">
			<div class="container1">
				<div class="sec01-cont">
						<h2>ようこそcomoriへ</h2>
						<div class="list">
							・ 週1回から自分の都合のよいスケジュールで続けられる<br/>
							・ 好きな時給を設定できる<br/>
							・ 家事代行もOK！<br/>
						</div>
				</div>
			</div>
    </section>
    <section id="sec02">
			<a href="#">登録面談会はこちら</a>
    </section>
    <section id="sec03">
			<div class="container1">
				<form @submit.prevent="request">
					<h2>応募フォーム</h2>
					<div class="sec03-cont">
						<div class="row1">
							<p>名前</p>
							<p>
								<input type="text" class="w270 m23 w120 m2" name="firstname" placeholder="姓" v-model.trim="$v.form.fn.$model"
                                v-bind:class="{ 'form--error': $v.form.fn.$error, 'form--noerror': !$v.form.fn.$invalid }">
								<input type="text" class="w270 w120" name="lastname" placeholder="名" v-model.trim="$v.form.ln.$model"
                                v-bind:class="{ 'form--error': $v.form.ln.$error, 'form--noerror': !$v.form.ln.$invalid }">
							</p>
						</div>
						<div class="row1">
							<p>フリガナ</p>
							<p>
								<input type="text" class="w270 m23 w120 m2" name="fname" placeholder="セイ" v-model.trim="$v.form.fn_kana.$model"
                                v-bind:class="{ 'form--error': $v.form.fn_kana.$error, 'form--noerror': !$v.form.fn_kana.$invalid }">
								<input type="text" class="w270 w120" name="lname" placeholder="メイ" v-model.trim="$v.form.ln_kana.$model"
                                v-bind:class="{ 'form--error': $v.form.ln_kana.$error, 'form--noerror': !$v.form.ln_kana.$invalid }">
							</p>
						</div>
						<div class="row1">
							<p>生年月日</p>
							<p>
								<input type="number" name="year" class="w115 m46 w50 m20" placeholder="YYYY" v-model.trim="$v.form.year.$model"
                                v-bind:class="{ 'form--error': $v.form.year.$error, 'form--noerror': !$v.form.year.$invalid }">
								<input type="number" name="month" class="w115 m46 w50 m20" placeholder="MM" v-model.trim="$v.form.month.$model"
                                v-bind:class="{ 'form--error': $v.form.month.$error, 'form--noerror': !$v.form.month.$invalid }">
								<input type="number" name="day" class="w115 w50" placeholder="DD" v-model.trim="$v.form.day.$model"
                                v-bind:class="{ 'form--error': $v.form.day.$error, 'form--noerror': !$v.form.day.$invalid }">
							</p>
						</div>
						<div class="row1">
							<p>メールアドレス</p>
							<p>
								<input type="email" class="w100" name="email" placeholder="@" v-model.trim="$v.form.email.$model"
                                v-bind:class="{ 'form--error': $v.form.email.$error, 'form--noerror': !$v.form.email.$invalid }">
							</p>
						</div>
						<div class="row1">
							<p>電話番号</p>
							<p>
								<input type="tel" class="w100" name="email" placeholder="000 - 0000 - 0000" v-model.trim="$v.form.phone.$model"
                                v-bind:class="{ 'form--error': $v.form.phone.$error, 'form--noerror': !$v.form.phone.$invalid }">
							</p>
						</div>
						<div class="row1">
							<p>その他コメント</p>
							<p>
								<textarea name="comment" placeholder="ご要望等ありましたらこちらへご記入くださいませ" v-model="form.model"></textarea>
							</p>
						</div>
						<div class="form-btn">
							<button type="submit">申し込む</button>
						</div>
						<div class="note">
							<router-link :to="{ name: 'terms' }" >利用規約</router-link>、<router-link :to="{ name: 'privacy' }">プライバシーポリシー</router-link> に同意の上、お申し込みください。<br/>
							お申し込み後、運営スタッフから折り返し詳細のご連絡を致します。
						</div>
					</div>
				</form>
			</div>
    </section>
    <section id="sec04">
			<div class="container1">
				<h2>
						よくある質問
				</h2>
				<div class="sec04-cont">
					<div class="item">
						<h3>Q. 未経験でもできますか？</h3>
						<p> 
								資格がなくても子育て経験や、子供と接した経験があれば活躍し<br/>
								ている方が多くいらっしゃいます。さらに、特技があれば人気の<br/>
								シッターになることができます。未経験でもすぐに働けるよう選<br/>
								考後に接遇や緊急時の対応についての無料研修を用意しています。<br/>
						</p>
					</div>
					<div class="item">
						<h3>Q. 時給はどのくらいですか？</h3>
						<p> 
								一般的に1000円〜1300円程度となりますが、2000〜2500円<br/>
								で予約が殺到するベビーシッターも多くいます。資格をお持ちの<br/>
								場合はさらに優遇されます。ただし、未経験者でもお人柄、育児<br/>
								経験やお子様と接した経験、特技、お住まいの地域などから総合<br/>
								的にみて、多くの依頼を得る方も多々いらっしゃいます。
						</p>
					</div>
					<div class="moreview">
						<a href="#">よくある質問をもっと見る</a>
					</div>
				</div>
			</div>
    </section>
    <footer class="pc1">
			Copyright © 2010‐2019 Axalpha, Inc. All Rights Reserved.
    </footer>
    <section id="sec05" class="sp1">
        <a href="#header" v-smooth-scroll>Top</a>
    </section>
    <Loading v-if="isLoading" />
  </div>
</template>
<script>
import { required, sameAs, numeric, url, email, minLength } from 'vuelidate/lib/validators'
import Loading from '@/components/main/Loading'

export default {
  data () {
    return {
      form: {
        fn: '',
        ln: '',
        fn_kana: '',
        ln_kana: '',
        year: '',
        month: '',
        day: '',
        email: '',
        phone: '',
        comment: ''
      },
      isLoading: false
    }
  },
  validations: {
    form: {
      fn: {
          required
      },
      ln: {
          required
      },
      fn_kana: {
          required
      },
      ln_kana: {
          required
      },
      year: {
          required, numeric
      },
      month: {
          required, numeric
      },
      day: {
          required, numeric
      },
      email: {
          required, email
      },
      phone: {
          required
      },
    }
  },
  components: {
    Loading
  },
  mounted () {
    
  },
  methods: {
    request() {
      this.$v.$touch()
      if (this.$v.$invalid) {
      } else {
        this.isLoading = true
        apiClient.sendSitterRequest(this.form).then(response => {
          this.isLoading = false
          this.$router.push({ name: 'success' })
        }).catch(error => {
          this.isLoading = false
        })
      }
    }
  }
}
</script>
<style scoped>
@charset "utf-8";

* { -webkit-box-sizing: border-box; -moz-box-sizing: border-box; -o-box-sizing: border-box; -ms-box-sizing: border-box; box-sizing: border-box; }
* { margin: 0px; padding: 0px; word-wrap: break-word; }
ul { list-style: none; }
body, ul, ol, li, dl, dt, dd, table, form, input, label { margin:0; padding:0; font-weight:normal; }
body {
    font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, メイリオ, Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", "ＭＳ ゴシック" , "MS Gothic", "Noto Sans CJK JP", TakaoPGothic, sans-serif;
    font-size: 18px; background-color: white; margin: 0; line-height:2.0; -webkit-text-size-adjust : 100%; color:#4A4A4A; background-color: #fff }
h1, h2, h3, h4, h5, ul { font-size:100%; margin:0; padding:0; }
hr { border:none; border-top:dashed 1px #CCC; height:1px; color:#FFFFFF; width:100%; margin-top:30px; margin-bottom:30px; }
th { font-weight:lighter; }
dt { font-weight: bold; }
strong { font-weight: bold; }
a { color: #00b0e3; font-weight: bold; text-decoration:none; font-size:100%; overflow:hidden; outline:none; }
a:hover { color:rgba(0,0,0, .5); transition: .4s ; text-decoration: none; }
a.blog_a { color: #000; font-weight: bold; text-decoration:none; font-size:100%; overflow:hidden; outline:none; }
a.blog_a:hover { color: #00acae; transition: .4s ; text-decoration: none; }
img { border: no; text-decoration:none;}
img { border: none; vertical-align: top; max-width: 100%; }
a img { border:none; }
a:hover img { opacity:0.5; filter: alpha(opacity=50); -ms-filter: "alpha( opacity=50 )"; transition: .4s ;  }
section{overflow: hidden;}

.container1 {
    width: 1024px;
    margin-left: auto;
    margin-right: auto;
}
#header {
    background-image: url(~@/assets/images/top-img.jpg);
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    position: relative;
    z-index: 1;
}

.form--error {
    box-shadow: 2px 2px 2px #5DC9CF;
    -webkit-appearance: none;
}

#header .container1 {
    position: relative;
    z-index: 3;
}

#header .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    z-index: 2;
}

#header .container1 h1 {
    padding-left: 41px;
    padding-top: 26px;
    z-index: 3;
    position: relative;
}

.header-cont {
    position: relative;
    z-index: 3;
    padding-left: 50px;
    margin-top: 50px;
}

.header-cont .photos {
    display: flex;
    margin-top: 36px;
}

.header-cont .left {
    padding-bottom: 30px;
}

.header-cont .left p {
    color: white;
    font-size: 40px;
    line-height: 60px;
    font-weight: 600;
}

.header-cont .left a {
    display: block;
}

.header-cont .register {
    width: 306px;
    height: 46px;
    line-height: 46px;
    border-radius: 8px;
    background-color: #5DC9CF;;
    color: white;
    text-align: center;
    font-size: 20px;
    margin-top: 25px;
}

.header-cont .appstore {
    margin-top: 40px;
    margin-left: 10px;
}

.header-cont .right {
    position: absolute;
    top: -15px;
    right: 62px;
}

.header-cont .photos p {
    margin-right: 25px;
}

#sec01 {
    text-align: center;
    padding-top: 55px;
}

#sec01 h2 {
    font-size: 36px;
    font-weight: 600;
    position: relative;
}

#sec01 h2:after {
    content: "";
    width: 416px;
    height: 22px;
    border-radius: 11px;
    background-image: linear-gradient(to right, #5DC9CF, #F3F3F3);
    position: absolute;
    bottom: -3px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: -1;
}

#sec01 .list {
    text-align: left;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    font-size: 22px;
    line-height: 50px;
    margin-top: 30px;
}

#sec02 {
    text-align: center;
    padding-top: 50px;
}

#sec02 a {
    display: inline-block;
    width: 560px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    color: white;
    font-size: 34px;
    font-weight: 500;
    background: #5DC9CF;
    border-radius: 10px;
    cursor: pointer;
}

#sec03 {
    padding-top: 60px;
}

#sec03 h2 {
    text-align: center;
    font-size: 32px;
    font-weight: 600;
}

#sec03 .container1 {
    padding-left: 115px;
    padding-right: 115px;
}

.sec03-cont {
    padding-top: 35px;
}

#sec03 .row1 p:first-of-type {
    font-size: 21px;
}

.w270 {
    width: 270px;
}

.w115 {
    width: 115px;
}

.m23 {
    margin-right: 23px;
}

.m46 {
    margin-right: 46px;
}

#sec03 .row1 {
    padding-right: 35px;
    border-bottom: 1px solid #F3F3F3;
    padding-bottom: 33px;   
    padding-top: 46px;
}

#sec03 .row1 p input {
    border: 1px solid #7070701a;
    border-radius: 4px;
    height: 46px;
    line-height: 46px;
    font-size: 21px;
    padding-left: 20px;
}

#sec03 .row1 p textarea {
    border: 1px solid #7070701a;
    border-radius: 4px;
    line-height: 46px;
    font-size: 21px;
    padding-left: 20px;
    height: 280px;
    width: 100%;
    resize: none;
}

#sec03 .row1 p input::placeholder {
    color: #70707052;
}

#sec03 .row1 p:last-of-type {
    padding-left: 185px;
}

.form-btn {
    padding-top: 45px;
    text-align: center;
}

 .form-btn button {
    background-color: #5DC9CF;
    color: white;
    font-weight: 600;
    font-size: 35px;
    text-align: center;
    width: 310px;
    height: 92px;
    line-height: 92px;
    border-radius: 46px;
}

#sec03 .note {
    padding-top: 43px;
    font-size: 22px;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
}

#sec03 .note a {
    font-size: 22px;
    color: #5DC9CF;
    text-decoration: underline;
}

#sec04 {
    padding-top: 80px;
    margin-bottom: 70px;
}

#sec04 h2 {
    font-size: 32px;
    color: #595668;
    text-align: center;
    margin-bottom: 40px;
}

.sec04-cont {
    position: relative;
}

#sec04 .container1 {
    border: 2px solid #70707026;
    border-radius: 10px;
    padding-top: 47px;
    width: 790px;
    margin-left: auto;
    margin-right: auto;
}

#sec04 .container1 h3 {
    font-size: 42px;
    color: #5DC9CF;
    font-weight: 500;
}

.sec04-cont {
    padding-bottom: 150px;
    padding-left: 60px;
    padding-right: 60px;
}

.sec04-cont .moreview {
    text-align: right;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #70707026;
    padding-right: 68px;
}

.sec04-cont .moreview a{
    font-size: 28px;
    color: #5DC9CF;
    background: white;
    display: inline-block;
    height: 100px;
    line-height: 100px;
}

#sec04 .item p {
    font-size: 22px;
    color: #5956688f;
}

footer {
    font-size: 12px;
    text-align: center;
    padding-bottom: 25px;
}

@media screen and (min-width: 1001px) {
    .sp1 {
        display: none !important;
    }
}

@media screen and (max-width: 1000px) {
    .pc1 {
        display: none !important;
    }

    .sp-logo {
        padding-top: 2.6vw;
        padding-left: 4vw;
    }

    .sp-logo img {
        width: 22vw;
    }

    .container1 {
        width: 100%;
    }

    #header .container1 h1 {
        padding-left: 10vw;
        padding-top: 3vw;
    }

    .header-cont {
        margin-top: 2vw;
        padding-left: 10vw;
    }

    .header-cont .left p {
        font-size: 4.5vw;
        line-height: 8vw;
    }

    .header-cont .photos {
        margin-top: 24vw;
    }

    .header-cont .photos p {
        margin-right: 2.6vw;
        width: 20vw;
    }

    .header-cont .photos p:first-of-type {
        margin-left: auto;
    }

    h1.sp1 img {
        width: 8vw;
        height: 8vw;
    }

    #sec02 a {
        width: 56vw;
        height: 10vw;
        line-height: 10vw;
        font-size: 4.5vw;
    }

    #sec02 {
        padding-top: 5vw;
    }

    #sec03 h2 {
        font-size: 4vw;
        line-height: 6vw;
    }

    #sec03 {
        padding-top: 11vw;
    }

    #sec03 .container1 {
        padding-left: 4vw;
        padding-right: 4vw;
    }

    .sec03-cont {
        padding-top: 4vw;
    }

    #sec03 .row1 {
        padding-right: 4vw;
        border-bottom: 1px solid #F3F3F3;
        padding-bottom: 3vw;
        padding-top: 4vw;
    }

    #sec03 .row1 p:first-of-type {
        font-size: 3vw;
    }

    .w120 {
        width: 34.2vw;
    }

    #sec03 .row1 p:last-of-type {
        padding-left: 16vw;
    }

    .m2 {
        margin-right: 2vw; 
    }

    #sec03 .row1 p input {
        height: 6vw;
        border-radius: 0.7vw;
        font-size: 2.8vw;
        padding-left: 3vw;
        line-height: 6vw;
    }

    .w50 {
        width: 14vw;
    }

    .m20 {
        margin-right: 6vw;
    }

    #sec03 .row1 p textarea {
        border-radius: 1vw;
        line-height: 4vw;
        height: 35vw;
        font-size: 2.8vw;
        padding-top: 1vw;
        padding-left: 3vw;
    }

    .form-btn {
        padding-top: 5.5vw;
    }

    .form-btn button {
        width: 38vw;
        height: 12vw;
        line-height: 12vw;
        font-size: 4.5vw;
        border: 0;
    }

    #sec03 .note {
        font-size: 2.8vw;
    }

    #sec03 .note a {
        font-size: 2.8vw;
    }

    #sec03 .note {
        padding-top: 6vw;
    }

    #sec04 {
        padding-top: 9vw;
    }

    #sec04 .container1 {
        border: 2px solid #70707026;
        border-radius: 2.8vw;
        padding-top: 5.5vw;
        width: 93vw;
    }

    #sec04 h2 {
        font-size: 4vw;
        margin-bottom: 4vw;
    }

    .sec04-cont {
        padding-left: 6vw;
        padding-right: 2vw;
        padding-bottom: 16vw;
    }

    #sec04 .container1 h3 {
        font-size: 5.2vw;
    }

    #sec04 .item p {
        font-size: 2.8vw;
    }

    .sec04-cont .moreview {
        padding-right: 6.8vw;
    }

    .sec04-cont .moreview a {
        font-size: 3.5vw;
        line-height: 13vw;
        height: 13vw;
    }

    #sec04 {
        margin-bottom: 9vw;
    }

    #sec05 {
        text-align: center;
        padding-bottom: 17vw;
    }

    #sec05 a {
        display: inline-block;
        width: 38vw;
        height: 10.5vw;
        line-height: 10.5vw;
        background-color: #5DC9CF;
        text-align: center;
        color: white;
        font-size: 5vw;
        border-radius: 5.5vw;
    }
}

.w100 {
    width: 100%;
}

html {
    scroll-behavior: smooth;
}

#sec03 .row1 p textarea::placeholder {
    color: #70707052;
}
</style>
